import { render } from "./filterEdit.vue?vue&type=template&id=60b4a412"
import script from "./filterEdit.vue?vue&type=script&lang=ts"
export * from "./filterEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script